export const iconFontAwesomeDevicesHardwareMobileButton = (
	<i className="fa-solid fa-mobile-button"></i>
);
